<div appAccessProvider [accessCode]="{ menuCode: 'DASHBOARD', pageCode: 'DASHBOARD'}">
    <p-breadcrumb [model]="routePath"></p-breadcrumb>
    <app-module-header [showLastSync]="true" (onRefreshList)="checkUserType()" [hideAuditBtn]="false"
        [showImportExportBtn]="false"></app-module-header>

    @if(isResize) {
    <p-tabView [scrollable]="true" class="dashboard-tab-view">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
                <span class="tab-label" translate>dashboard.lbl_dashboard</span>
            </ng-template>
            <ng-template pTemplate="body">
                <div class="filter-container">
                    @if(configService.isSponsor() ){
                    <div class="filter-form">
                        @if(selectedProtocol) {


                        <div class="relative inline-block">
                            <i class="mi-lg trial wh-24 protocol-icon"></i>
                            <p-autoComplete
                                [(ngModel)]="selectedProtocol"
                                [dropdown]="true"
                                [suggestions]="filteredProtocolItems"
                                (completeMethod)="filterProtocolItems($event)"
                                (onSelect)="onSelectItem($event)"
                                optionLabel="name"
                                [disabled]="field?.disabled"
                                [placeholder]="placeholder" />

                        </div>


                        <div class="relative inline-block">
                            <i class=" wh-24 protocol-icon icon-color"> <svg width="20" height="20" viewBox="0 0 20 20"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M2.48 17.912H17.52a.396.396 0 0 0 .396-.396v-9.5a.396.396 0 0 0-.396-.396h-1.979V4.057a.396.396 0 0 0-.396-.396h-1.979v-.395a1.187 1.187 0 0 0-1.187-1.188H8.02a1.188 1.188 0 0 0-1.187 1.188v.395h-1.98a.396.396 0 0 0-.395.396V7.62h-1.98a.396.396 0 0 0-.395.396v9.5a.396.396 0 0 0 .396.396zm13.062-9.5h1.584v8.708h-1.584V8.41zm-4.354 8.708H8.813v-2.771h2.375v2.77zM7.626 3.266a.396.396 0 0 1 .395-.396h3.959a.396.396 0 0 1 .396.396v3.958a.396.396 0 0 1-.396.396H8.02a.396.396 0 0 1-.395-.396V3.266zM5.25 4.453h1.583v2.771a1.188 1.188 0 0 0 1.187 1.187h3.959a1.187 1.187 0 0 0 1.187-1.187v-2.77h1.584V17.12H11.98v-3.167a.396.396 0 0 0-.396-.396H8.417a.396.396 0 0 0-.396.396v3.167h-2.77V4.453zM2.876 8.411h1.583v8.709H2.876V8.41z"
                                        fill="#777" stroke="#777" stroke-width=".4" />
                                    <path
                                        d="M8.814 5.643h.791v.792a.396.396 0 1 0 .792 0v-.792h.792a.396.396 0 1 0 0-.791h-.792V4.06a.396.396 0 1 0-.792 0v.792h-.791a.396.396 0 0 0 0 .791z"
                                        fill="#777" stroke="#777" stroke-width=".4" />
                                </svg>
                            </i>
                            <p-autoComplete
                                [(ngModel)]="selectedSite"
                                [dropdown]="true"
                                [suggestions]="filteredSiteItems"
                                (completeMethod)="filterSiteItems($event)"
                                (onSelect)="onSelectSite($event)"
                                (onDropdownClick)="onSiteDropdownOpen()"
                                (onFocus)="onSiteFocus()"
                                optionLabel="name"
                                minLength="0"
                                [placeholder]="sitePlaceholder" />
                        </div>
                        }
                    </div>
                    }
                </div>
                @if(configService.isSponsor() ){
                @if(protocolForecastData?.protocolEstimatedPatientCount === 0) {
                <div class="mb-4">
                    <p-message severity="warn"
                        [text]="'Please update the Estimated Patient Count field in the Add Protocol form to render the graph correctly.'"
                        [closable]="false" styleClass="w-full">
                    </p-message>
                </div>
                }
                @if(selectedProtocol ) {
                <div class="dashboard-bg">
                    <div class="dashboard-cards-container">
                        @if(isSponsor && selectedSite?.id === 'all') {
                        <app-sponsor-cards [protocolForecastData]="protocolForecastData"></app-sponsor-cards>
                        }
                        @if(isSponsor) {

                        @if(selectedSite?.id !== 'all') {

                            <div class="dashboard-charts-grid">
                                <div class="dashboard-chart-section overflow-auto">
                                    <app-order-history [siteId]="selectedSite?.id"
                                        [protocolId]="selectedProtocol?.id"></app-order-history>
                                        <app-expected-vs-active-patients
                                        [protocolForecastData]="protocolForecastData"></app-expected-vs-active-patients>
                                </div>

                                <div class="dashboard-chart-section">
                                   
                                    <app-soaproduct-volumes class="no-top-margin"
                                        [productSoaCount]="productSoaCount"></app-soaproduct-volumes>
                                        <!-- <app-forcasted-spend-for-next-billing-period
                                        [protocolForecastData]="protocolForecastData"></app-forcasted-spend-for-next-billing-period> -->
                                        <!-- <app-budgeted-vs-forcasted-widget [protocolForecastData]="protocolForecastData">
                                        </app-budgeted-vs-forcasted-widget> -->
                                    </div>

                                <div class="dashboard-chart-section">
                                  
                                </div>
                                <div class="dashboard-chart-section">
                                  
                                </div>
                            </div>
                            <div class="dashboard-charts-grid">
                              
    
    
                               
                            </div>

                        <!-- <div class="dashboard-charts-grid">
                            <div class="dashboard-chart-section">
                                <app-expected-vs-active-patients
                                    [protocolForecastData]="protocolForecastData"></app-expected-vs-active-patients>
                            </div>
                            <div class="dashboard-chart-section">
                                <app-budgeted-vs-forcasted-widget [protocolForecastData]="protocolForecastData">
                                </app-budgeted-vs-forcasted-widget>
                            </div>
                        </div>
                        <div class="dashboard-charts-grid">
                            <div class="dashboard-chart-section">
                                <app-forcasted-spend-for-next-billing-period
                                    [protocolForecastData]="protocolForecastData"></app-forcasted-spend-for-next-billing-period>
                                <app-soaproduct-volumes
                                    [productSoaCount]="productSoaCount"></app-soaproduct-volumes>
                            </div>


                            <div class="dashboard-chart-section overflow-auto">
                                <app-order-history [siteId]="selectedSite?.id"
                                    [protocolId]="selectedProtocol?.id"></app-order-history>
                            </div>
                        </div> -->

                        }


                        @if(selectedSite?.id === 'all') {


                            <div class="dashboard-charts-grid">
                                <div class="dashboard-chart-section">
    
                                   
                                    <app-remaining-budget-vs-po
                                        [protocolForecastData]="protocolForecastData"
                                        [forecastData]="protocolForecastData"></app-remaining-budget-vs-po>
                                          <!-- <app-budgeted-vs-forcasted-widget
                                        [protocolForecastData]="protocolForecastData">
                                    </app-budgeted-vs-forcasted-widget> -->
                                </div>
                                <div class="dashboard-chart-section">
                                    <app-soaproduct-volumes
                                    [productSoaCount]="productSoaCount"></app-soaproduct-volumes>
                                   
                                    <!-- <app-forcasted-spend-for-next-billing-period
                                    [protocolForecastData]="protocolForecastData"></app-forcasted-spend-for-next-billing-period> -->
                          
                                   
                                </div>
                            
                                
                            </div>



                        <!-- <div class="dashboard-charts-grid">
                            <div class="dashboard-chart-section">
                                <app-budgeted-vs-forcasted-widget [protocolForecastData]="protocolForecastData">
                                </app-budgeted-vs-forcasted-widget>

                                <app-soaproduct-volumes
                                    [productSoaCount]="productSoaCount"></app-soaproduct-volumes>
                            </div>
                            <div class="dashboard-chart-section">

                                <app-forcasted-spend-for-next-billing-period
                                    [protocolForecastData]="protocolForecastData"></app-forcasted-spend-for-next-billing-period>
                                <app-remaining-budget-vs-po
                                    [protocolForecastData]="protocolForecastData"
                                    [forecastData]="protocolForecastData"></app-remaining-budget-vs-po>
                            </div>
                        </div> -->
                        }


                        }

                    </div>
                </div>

                }@else {
                <div class="dashboard-bg">
                    <div class="dashboard-cards-container">
                        <app-no-result-found></app-no-result-found>
                    </div>
                </div>
                }
                }
                <div class="dashboard-bg">
                    <div class="dashboard-cards-container">


                        @if(isSiteUser) {
                        <div class="dashboard-row pt-5">


                            <div class="dashboard-card cursor-pointer" (click)="navigateToOrders()">
                                <div class="label font-semibold text-lg" translate>dashboard.lbl_total_number_of_orders
                                </div>
                                @if (siteAndAdminCount?.orderCountDto) {
                                <div class="mt-1 text-4xl font-bold text-blue-600">
                                    {{siteAndAdminCount.orderCountDto.total}}</div>
                                } @else {
                                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                                }
                            </div>
                            <div class="dashboard-card cursor-pointer" (click)="navigateToPendingOrders()">
                                <div class="label font-semibold text-lg" translate>dashboard.lbl_pending_orders</div>
                                @if (siteAndAdminCount?.orderCountDto) {
                                <div class="mt-1 text-4xl font-bold">{{siteAndAdminCount.orderCountDto.pending}}</div>
                                } @else {
                                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                                }
                            </div>
                            <div class="dashboard-card cursor-pointer" (click)="navigateToCompletedOrders()">
                                <div class="label font-semibold text-lg" translate>dashboard.lbl_completed_orders</div>
                                @if (siteAndAdminCount?.orderCountDto) {
                                <div class="mt-1 text-4xl font-bold">{{siteAndAdminCount.orderCountDto.completed}}</div>
                                } @else {
                                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                                }
                            </div>
                            <div class="dashboard-card cursor-pointer" (click)="navigateToRejectedOrders()">
                                <div class="label font-semibold text-lg" translate>dashboard.lbl_rejected_orders</div>
                                @if (siteAndAdminCount?.orderCountDto) {
                                <div class="mt-1 text-4xl font-bold text-red-500">
                                    {{siteAndAdminCount.orderCountDto.rejected}}
                                </div>
                                } @else {
                                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                                }
                            </div>
                        </div>
                        }
                        @if(isAdmin) {
                        <div class="dashboard-row pt-5">

                            <div class="dashboard-card cursor-pointer" (click)="navigateToSites()">
                                <div class="label font-semibold text-lg" translate>dashboard.lbl_total_sites</div>
                                @if (siteAndAdminCount) {
                                <div class="mt-1 text-4xl font-bold text-green-500">{{siteAndAdminCount.siteCount}}
                                </div>
                                } @else {
                                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                                }
                            </div>
                            <div class="dashboard-card cursor-pointer" (click)="navigateToProtocols()">
                                <div class="label font-semibold text-lg" translate>dashboard.lbl_total_protocols</div>
                                @if (siteAndAdminCount) {
                                <div class="mt-1 text-4xl font-bold text-purple-500">{{siteAndAdminCount.protocolCount}}
                                </div>
                                } @else {
                                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                                }
                            </div>
                            <div class="dashboard-card cursor-pointer" (click)="navigateToOrders()">
                                <div class="label font-semibold text-lg" translate>dashboard.lbl_total_number_of_orders
                                </div>
                                @if (siteAndAdminCount?.orderCountDto) {
                                <div class="mt-1 text-4xl font-bold text-blue-600">
                                    {{siteAndAdminCount.orderCountDto.total}}</div>
                                } @else {
                                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                                }
                            </div>

                        </div>
                        }

                        <div class="flex justify-between">
                            @if(isSiteUser || isAdmin) {
                            <div class="dashboard-protocols-card cursor-pointer" (click)="navigateToProtocols()">
                                <div class="label font-semibold text-lg mb-2" translate>dashboard.lbl_protocols</div>
                                @if (siteAndAdminCount?.protocolCountDto) {
                                <div class="text-4xl font-bold mb-1">{{siteAndAdminCount.protocolCountDto.total}}</div>
                                <div class="text-base mb-4">Total Protocols</div>
                                <div class="protocol-bar">
                                    <div
                                        class="protocol-bar-completed"
                                        [style.width]="(siteAndAdminCount.protocolCountDto.completed/siteAndAdminCount.protocolCountDto.total*100)+'%'"
                                        pTooltip="Completed Protocols: {{siteAndAdminCount.protocolCountDto.completed}}"
                                        tooltipPosition="top"></div>
                                    <div
                                        class="protocol-bar-running"
                                        [style.width]="(siteAndAdminCount.protocolCountDto.running/siteAndAdminCount.protocolCountDto.total*100)+'%'"
                                        pTooltip="Running Protocols: {{siteAndAdminCount.protocolCountDto.running}}"
                                        tooltipPosition="top"></div>
                                </div>

                                <div class="flex justify-between mt-2 gap-x-8">
                                    <div class="self-start">
                                        <div class="legend bg-blue-500 rounded-full mr-2"></div> <span
                                            class="font-semibold text-lg mr-1">{{siteAndAdminCount.protocolCountDto.completed}}</span>
                                    </div>
                                    <div class="self-end">
                                        <div class="legend bg-green-400 rounded-full mr-2"></div>
                                        <span
                                            class="font-semibold text-lg mr-1">{{siteAndAdminCount.protocolCountDto.running}}</span>
                                    </div>
                                </div>
                                <div class="flex justify-between mt-2 gap-x-8">
                                    <div class="flex items-center">
                                        <span class="text-sm mr-2">Completed Protocols</span>
                                    </div>
                                    <div class="flex items-center">
                                        <span class="text-sm">Running Protocols</span>
                                    </div>
                                </div>
                                } @else {
                                <p-skeleton height="6rem" class="mt-1"></p-skeleton>
                                }
                            </div>
                            }

                            @if(isAdmin) {
                            <div class="dashboard-protocols-card cursor-pointer ml-4" (click)="navigateToOrders()">
                                <div class="label font-semibold text-lg mb-2">Orders</div>
                                <div class="flex items-end gap-3 mb-2">
                                    <div class="order-completed">
                                        <div class="text-4xl font-bold mb-1">{{siteAndAdminCount?.orderCountDto?.total
                                            || 0}}</div>
                                        <div class="text-base text-gray-500">Total orders</div>
                                    </div>
                                    <div class="border-l h-8 mx-2"></div>
                                    <div>
                                        <div class="text-2xl font-bold mb-1" style="height: 38px;">
                                            {{siteAndAdminCount?.orderCountDto?.pending || 0}}
                                        </div>
                                        <div class="text-base text-gray-500">Pending</div>
                                    </div>
                                    <div>
                                        <div class="text-2xl font-bold mb-1" style="height: 38px;">
                                            {{siteAndAdminCount?.orderCountDto?.completed || 0}}
                                        </div>
                                        <div class="text-base text-gray-500">Completed</div>
                                    </div>
                                </div>
                                <hr class="my-2" />
                                <div class="order-bar">
                                    <div
                                        class="order-bar-accepted"
                                        [style.width]="(siteAndAdminCount?.orderCountDto?.accepted/siteAndAdminCount?.orderCountDto?.total*100)+'%'"
                                        pTooltip="Accepted: {{siteAndAdminCount?.orderCountDto?.accepted}}"
                                        tooltipPosition="top"></div>
                                    <div
                                        class="order-bar-rejected"
                                        [style.width]="(siteAndAdminCount?.orderCountDto?.rejected/siteAndAdminCount?.orderCountDto?.total*100)+'%'"
                                        pTooltip="Rejected: {{siteAndAdminCount?.orderCountDto?.rejected}}"
                                        tooltipPosition="top"></div>
                                </div>
                                <div class="flex justify-between mt-2 gap-x-8">
                                    <div class="self-start">
                                        <div class="legend bg-green-400 rounded-full mr-2"></div> <span
                                            class="font-semibold text-lg mr-1">{{siteAndAdminCount?.orderCountDto?.accepted
                                            || 0}}</span>
                                    </div>
                                    <div class="self-end">
                                        <div class="legend bg-red-400 rounded-full mr-2"></div>
                                        <span
                                            class="font-semibold text-lg mr-1">{{siteAndAdminCount?.orderCountDto?.rejected
                                            || 0}}</span>
                                    </div>
                                </div>
                                <div class="flex justify-between mt-2 gap-x-8">
                                    <div class="flex items-center">
                                        <span class="text-sm mr-2">Accepted</span>
                                    </div>
                                    <div class="flex items-center">
                                        <span class="text-sm">Rejected</span>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>

            </ng-template>
        </p-tabPanel>
    </p-tabView>
    }
</div>